import { baseUrl } from './config';

// ************************* Get Requests **************************
const getactiveusers = `${baseUrl}users/getactiveusers`;
const getActiveUsersWithCompleteSignup = `${baseUrl}users/getActiveUsersWithCompleteSignup`;
const getProviderClients = `${baseUrl}users/getProviderClients`;
const getarchivedusers = `${baseUrl}users/getarchivedusers`;

const getSolutionCoaches = `${baseUrl}solution-coach/solution-coaches`;
const getForYouCategory = `${baseUrl}for-you-category/foryou-category`;
const getForYouVideos = `${baseUrl}for-you-category/for-you-videos`;
const getFutureSelfQuestions = `${baseUrl}futureSelf/future-self-questions`;
const updateCategoryPositions = `${baseUrl}for-you-category/positions`;
const updateVideoPositions = `${baseUrl}for-you-category/video-positions`;
const getAllUserChatSessionsForAdmin = `${baseUrl}/prompts/getAllUserChatSessionsForAdmin`;

const getJourneys = `${baseUrl}futureSelf/getAllJourneys`;

const getactiveproviders = `${baseUrl}specialist/getactiveproviders`;
const getProvidersWithJoinSessionPermission = `${baseUrl}specialist/getProvidersWithJoinSessionPermission`;
const getActiveProvidersForAppointment = `${baseUrl}specialist/getActiveProvidersForAppointment`;
const getarchivedproviders = `${baseUrl}specialist/getarchivedproviders`;

const getcompletedappointments = `${baseUrl}appointment/getstatus?filter=Completed`;
const getupcomingappointments = `${baseUrl}appointment/getstatus?filter=Upcoming`;
const getcancelledappointments = `${baseUrl}appointment/getstatus?filter=Cancelled`;
const getnoshowappointments = `${baseUrl}appointment/getstatus?filter=No Show`;

const getNavigatorChangeReasons = `${baseUrl}specialist/get/healthnavreason`;
const getCoachChangeReasons = `${baseUrl}specialist/get/healthcoachreason`;

const getNavigatorRequests = `${baseUrl}admin/request/navigators`;
const getCoachRequests = `${baseUrl}admin/request/coaches`;

const getopensupportrequests = `${baseUrl}admin/support/open`;
const getclosedsupportrequests = `${baseUrl}admin/support/close`;

const getbusinesses = `${baseUrl}business/getBusinessPaginated`;

const getmembershipPlan = `${baseUrl}membershipPlan/getMembershipPlanPaginated`;

const getAllBlogs = `${baseUrl}blog/getallblogs`;

const getAllMembers = `${baseUrl}member/getMemberPaginated`;
const getAllRoles = `${baseUrl}role/getRolePaginated`;

// ******************************* PUT  Requests **********************************
const updaterequest = `${baseUrl}admin/request/update`;
const updateBusinessStatus = `${baseUrl}business/changeBusinessStatus`;
const updateRole = `${baseUrl}role/editRole`;

// ******************************* DELETE Requests **********************************
const deleterequest = `${baseUrl}admin/request`;
const deleteRole = `${baseUrl}role/deleteRole`;

export {
  getactiveusers,
  getarchivedusers,
  getactiveproviders,
  getarchivedproviders,
  getcancelledappointments,
  getcompletedappointments,
  getnoshowappointments,
  getupcomingappointments,
  getNavigatorChangeReasons,
  getCoachChangeReasons,
  getbusinesses,
  getmembershipPlan,
  getCoachRequests,
  getNavigatorRequests,
  getopensupportrequests,
  getclosedsupportrequests,
  getAllBlogs,
  getAllMembers,
  getAllRoles,
  updaterequest,
  updateBusinessStatus,
  updateRole,
  deleterequest,
  deleteRole,
  getActiveUsersWithCompleteSignup,
  getActiveProvidersForAppointment,
  getProvidersWithJoinSessionPermission,
  getSolutionCoaches,
  getForYouCategory,
  getForYouVideos,
  updateCategoryPositions,
  updateVideoPositions,
  getFutureSelfQuestions,
  getAllUserChatSessionsForAdmin,
  getJourneys,
  getProviderClients
};
